import * as React from 'react';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

export const SuccessCheckCircleIcon = () => {
  return (
    <CheckCircleOutlineIcon 
      sx={{ 
        fill: '#12b36a',
        fontSize: '24px', 
        marginBottom: '-4px',
        marginRight: '4px'
      }} 
    />
  );
};


// WEBPACK FOOTER //
// ./src/components/icons/SuccessCheckCircleIcon.jsx